import React,{useState,useEffect} from 'react'

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation,Pagination } from "swiper";

import { firestore } from '../../../firebase.config';
import { collection, getDocs,query, orderBy } from 'firebase/firestore';
import './projects.css'

const Projects = () => {
    
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                // const querySnapshot = await getDocs(collection(firestore, 'projects'));
                const q = query(collection(firestore, 'projects'), orderBy('id'));
                const querySnapshot = await getDocs(q);
                const postsData = querySnapshot.docs.map(doc => doc.data());
                setProjects(postsData);
            } catch (error) {
                console.error("Error fetching data:");
            }
        };
        fetchData();
    }, []);

    return (
    <>
        <section className="projects section" id="projects">
                <h2 className="section__title">Projects</h2>
                <span className="section__subtitle">Most recent work</span>

                <div className="container section__border">

                    <Swiper className='projects__scroll' loop={true} pagination={{dynamicBullets: true}} navigation={{
                            prevEl: '.swiper-button-prev-eng',
                            nextEl: '.swiper-button-next-eng',
                        }}
                        modules={[Navigation,Pagination]} breakpoints={{1200:{slidesPerView:2,spaceBetween:-56}}}
                        >
                        
                        {projects.map((item,index)=>{
                            return(
                                <SwiperSlide className='projects__content' key={index}>
                                    <img className="projects__img" src={item.ImageUrl} alt="projects"/>
                                    
                                    <div>
                                        <span className="projects__subtitle">{item.subTitle}</span>
                                        <h1 className="projects__title">{item.titleProject}</h1>
                                        <a href={item.Link} rel="noreferrer" target="_blank" className="projects__button">
                                            View demo <i className="ri-arrow-right-line"></i>
                                        </a>
                                    </div>
                                </SwiperSlide>
                            )
                        })}

                        <div className='swiper-button-prev-eng'>
                            <i className="ri-arrow-left-s-line"></i>
                        </div>
                        <div className='swiper-button-next-eng'>
                            <i className="ri-arrow-right-s-line"></i>
                        </div>
                    </Swiper>
                    
                </div>
        </section>
    </>
    )
}

export default Projects